import { useApolloClient, useMutation, useQuery } from "@apollo/client";
import { useNavigate, useParams } from "react-router-dom";
// Redux
import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import {
  onPartnerProfileDataChange,
  onPartnerProfileRender,
} from "../../../features/partner/partner-profile-slice";
import { Button, Breadcrumbs, Modal } from "../../../components/core";
import {
  PARTNER_CATEGORY,
  PARTNER_TYPE_FOR_PARTNER,
  ID_TYPES,
  PAYMENT_MODES,
  SEARCH_PARTNERS,
  UPDATE_PARTNER_PROFILE,
} from "../../../constants/graphql/partners-query";

import { useForm } from "react-hook-form";
import useSidebarStore from "../../../zustand/stores/sidebar-store";
import { Strings } from "../../../constants/strings";
import PartnerProfileForm from "./component/partner-profile-form";
import { onClearDataReducer } from "../../../features/partner/add-partner-slice";
import { items } from "./component/add-profile";
import PartnerAdminAccount from "./component/admin-account";
import PartnerWalletConfiguration from "./component/step-two";
const breadcrumbItems = [
  {
    label: "Partner",
    path: `/partners/`,
  },
  { label: "Partner Profile", path: "#" },
];
function areRequiredFieldsEmptyOrNull(obj) {
  const requiredFields = [
    "operatorId",
    "partnerId",
    "partnerCategoryNo",
    "address",
    "tinNumber",
    "contactPerson",
    "contactPerson2",
    "zipCode",
    "mobile",
    "mobile2",
    "email",
    "email2",
    "partnerStatus",
  ];

  for (const key of requiredFields) {
    if (obj[key] === null || obj[key] === "") {
      return true; // At least one required field is empty or null
    }
  }
  return false; // All required fields are filled
}

export function hasExistingAdminAccount(partnerAccounts) {
  if (!partnerAccounts || partnerAccounts.length === 0) {
    return false;
  }
  return partnerAccounts.some((account) => account.adminAccess === true);
}

function PartnerProfileComponent() {
  const [EditingFlag, setEditingFlag] = useState(false);
  const navigate = useNavigate();
  // React Hook Form
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const contactPersonFields = [
    {
      index: 1,
      suffix: "",
      fields: {
        contactPerson: "contactPerson",
        contactPosition: "contactPosition",
        mobile: "mobile",
        email: "email",
        landline: "landline",
      },
    },
    {
      index: 2,
      suffix: "2",
      fields: {
        contactPerson: "contactPerson2",
        contactPosition: "contactPosition2",
        mobile: "mobile2",
        email: "email2",
        landline: "landline2",
      },
    },
  ];

  const { operatorId, partnerId } = useParams();

  const [changesMade, setChangesMade] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  // Utils
  const client = useApolloClient();
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions,
  );
  const [partnerTypeEditedIf, setPartnerTypeEditedIf] = useState();
  const dispatch = useDispatch();
  const searchPartner = useQuery(SEARCH_PARTNERS, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      partnerId: parseInt(partnerId),
    },
  });
  const partnerTypes = useQuery(PARTNER_TYPE_FOR_PARTNER, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      partnerCategoryNo:
        searchPartner.data &&
        searchPartner.data.searchCouriers[0].partnerType.partnerCategory
          .partnerCategoryNo,
    },
  });
  const partnerCategory = useQuery(PARTNER_CATEGORY);
  const idTypes = useQuery(ID_TYPES);
  const paymentSchedules = useQuery(PAYMENT_MODES);

  // zustand
  const pendingNavigation = useSidebarStore((state) => state.pendingNavigation);
  const setPendingNavigation = useSidebarStore(
    (state) => state.setPendingNavigation,
  );
  const activeSubItem = useSidebarStore((state) => state.activeSubItem);
  const setActiveSubItem = useSidebarStore((state) => state.setActiveSubItem);

  //Mutation
  const [updateCourierProfile, { data, loading, error }] = useMutation(
    UPDATE_PARTNER_PROFILE,
  );
  const [partnerTypesItems, setPartnerTypesItems] = React.useState([]);
  const [partnerCategoryItems, setPartnerCategoryItems] = React.useState([]);
  const [idTypesItem, setIdTypesItem] = React.useState([]);
  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "Invalid data",
    message: "",
    open: false,
  });
  const [paymentSchedulesItem, setPaymentSchedulesItem] = React.useState([]);
  const partnerProfileData = useSelector(
    (state) => state.partnerProfile.partnerProfileData,
  );

  console.log({ partnerProfileData });
  const [openSaveModal, setOpenSaveModal] = React.useState(false);
  const [openCancelModal, setOpenCancelModal] = React.useState(false);
  const [isAlreadyExisting, setIsAlreadyExisting] = useState(false);

  useEffect(() => {
    if (searchPartner.data) {
      var searchPartnerData = searchPartner.data.searchCouriers[0];
      if (hasExistingAdminAccount(searchPartnerData.partnerAccounts)) {
        setIsAlreadyExisting(true);
      } else {
        setIsAlreadyExisting(false);
      }

      dispatch(onPartnerProfileRender(searchPartnerData));
    }
  }, [searchPartner.data]);

  React.useEffect(() => {
    if (partnerCategory.data) {
      var tempArr = [];
      partnerCategory.data.partnerCategories.forEach((element) => {
        tempArr.push({
          value: element.partnerCategoryNo,
          name: element.partnerCategory,
        });
      });
      setPartnerCategoryItems(tempArr);
    }
  }, [partnerCategory.data]);
  React.useEffect(() => {
    if (partnerTypes.data && searchPartner.data) {
      // searchPartner.data.searchCouriers[0].partnerType.partnerCategory.partnerCategory
      var tempArr = [];
      partnerTypes.data.partnerTypes.forEach((element) => {
        tempArr.push({
          value: element.partnerTypeId,
          name: element.partnerType,
        });
      });
      setPartnerTypesItems(tempArr);
    }
  }, [partnerTypes.data]);
  React.useEffect(() => {
    if (idTypes.data) {
      var tempArr = [];
      idTypes.data.idTypes.forEach((element) => {
        tempArr.push({
          value: element.idTypeId,
          label: element.idType,
        });
      });
      setIdTypesItem(tempArr);
    }
  }, [idTypes.data]);
  const [callOnce, setCallOnce] = useState(true);

  React.useEffect(() => {
    if (paymentSchedules.data) {
      var tempArr = [];
      paymentSchedules.data.paymentSchedules.forEach((element) => {
        tempArr.push({
          value:
            element.paymentScheduleNo === 0 ? -2 : element.paymentScheduleNo,
          name: element.paymentSchedule,
        });
      });
      setPaymentSchedulesItem(tempArr);
    }
  }, [paymentSchedules.data]);
  const handleOnChange = (event) => {
    // setCallOnce(false);
    setEditingFlag(true);
    setChangesMade(true);
    const { name, value, checked } = event.target;
    if (
      name === "tinNumber" ||
      name === "zipCode" ||
      name === "mobile" ||
      name === "mobile2"
      // ||
      // name === "landline" ||
      // name === "landline2"
    ) {
      // const tinRegex = /^\d+$/;
      const tinRegex = /^\d*$/;

      if (!tinRegex.test(value)) {
        setChangesMade(false);
        return; // Exit if the validation fails
      }
    }

    if (name == "partnerTypeId") {
      setPartnerTypeEditedIf(value);
    }

    dispatch(onPartnerProfileDataChange({ name, value, checked }));
  };
  const handleCancelChanges = () => {
    dispatch(onClearDataReducer());
    navigate(`/partners`);
  };
  const showValidationError = (message) => {
    setValidation({
      icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
      title: Strings.popup_error_title,
      message,
      open: true,
      actions: (
        <div className="grid grid-cols-1 gap-2">
          <Button
            value={"OK"}
            className={"p-2"}
            onClick={() => setValidation(false)}
          />
        </div>
      ),
    });
  };

  const handleSaveChanges = () => {
    if (
      areRequiredFieldsEmptyOrNull(partnerProfileData) ||
      partnerProfileData.partnerTypeId === -1 ||
      partnerProfileData.partnerTypeId === "-1" ||
      partnerProfileData.partnerTypeId === undefined
    ) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid entry",
        message: "Please fill all required fields.",
        open: true,
        actions: (
          <div className="grid grid-cols-1 gap-2">
            <Button
              onClick={() => {
                setValidation({
                  open: false,
                });
              }}
              value={"OK"}
              className={"p-2"}
            />
          </div>
        ),
      });
    } else {
      //

      client.clearStore();
      const idsArr = partnerProfileData.ids.map((element) => element.value);

      // Create a new object with the updated ids property
      const updatedData = {
        ...partnerProfileData,
        ids: idsArr,
        agentTopupSourceNo:
          partnerProfileData.agentTopupSourceNo === -2
            ? 0
            : partnerProfileData.agentTopupSourceNo,
        // agentSourceFundNo intentionally omitted: agent_fund_source_no column
        // does not exist on the live database yet.
        // agentSourceFundNo: parseInt(partnerProfileData.agentSourceFundNo ?? 0),
      };
      delete updatedData.agentSourceFundNo;
      delete updatedData.partnerCategoryNo;
      delete updatedData.walletBalance;
      // delete updatedData.landline;
      // delete updatedData.landline2;
      if (partnerTypeEditedIf != null) {
        updatedData.partnerTypeId = partnerTypeEditedIf;
      }

      // if (landlineAreaCode != "" && landline1 != "") {
      //   updatedData.landline = landlineAreaCode + "*" + landline1;
      // }
      // if (landlineAreaCode2 != "" && landline2 != "") {
      //   updatedData.landline2 = landlineAreaCode2 + "*" + landline2;
      // }
      updateCourierProfile({ variables: { couriers: [updatedData] } })
        .then((data) => {
          searchPartner
            .refetch({
              operatorId: localStorage.getItem("user")
                ? JSON.parse(localStorage.getItem("user")).operator_id
                : "",
              partnerId: parseInt(partnerId),
            })
            .then((data) => {
              var searchPartnerData = data.data.searchCouriers[0];
              dispatch(onPartnerProfileRender(searchPartnerData));
              setValidation({
                icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
                title: Strings.popup_success_title_default,
                message: Strings.popup_success_message_edit,
                open: true,
                actions: (
                  <div className="grid grid-cols-1 gap-2">
                    <Button
                      onClick={() => {
                        setValidation({
                          open: false,
                        });
                        setChangesMade(false);
                        // window.location.reload();
                        goToNextStep(partnerId);
                      }}
                      value={"OK"}
                      className={"p-2"}
                    />
                  </div>
                ),
              });
            });
        })
        .catch((e) => {
          if (e.message.includes("duplicate")) {
            setValidation({
              icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
              title: Strings.popup_error_title,
              message: Strings.popup_error_message_duplicate,
              open: true,
              actions: (
                <div className="grid grid-cols-1 gap-2">
                  <Button
                    value={"OK"}
                    className={"p-2"}
                    onClick={() => setValidation(false)}
                  />
                </div>
              ),
            });
          } else {
            setValidation({
              icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
              title: Strings.popup_error_title,
              message: Strings.popup_error_message_edit,
              open: true,
              actions: (
                <div className="grid grid-cols-1 gap-2">
                  <Button
                    value={"OK"}
                    className={"p-2"}
                    onClick={() => setValidation(false)}
                  />
                </div>
              ),
            });
          }
        });
    }

    setOpenSaveModal(false);
  };
  useEffect(() => {
    if (pendingNavigation !== null) {
      if (changesMade) {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: `${Strings.popup_confirm_cancel_title}?`,
          message: Strings.popup_confirm_cancel_massage,
          open: true,
          actions: (
            <div className="flex justify-between gap-3">
              <Button
                onClick={() => {
                  setValidation({ open: false });
                  // window.location.reload();
                  setPendingNavigation(null);
                  setActiveSubItem(activeSubItem);
                }}
                value={"No"}
                className={"p-2 w-full"}
              />
              <Button
                onClick={() => {
                  navigate(pendingNavigation);
                  setPendingNavigation(null);
                }}
                value={"Yes"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });
      } else {
        navigate(pendingNavigation);
        setPendingNavigation(null);
      }
    }
  }, [pendingNavigation, changesMade]);

  const handleResetFeatures = () => {
    // Reset all feature checkboxes to unchecked (0)
    const featureFields = ["featuresCod", "featuresShipout", "featuresReturns"];

    featureFields.forEach((fieldName) => {
      dispatch(
        onPartnerProfileDataChange({
          name: fieldName,
          value: 0,
          checked: false,
        }),
      );
    });

    setChangesMade(true);
  };

  const goToNextStep = () => {
    const nextIndex = activeIndex + 1;

    // If we're on the last page (Admin Account - index 2), reload
    if (activeIndex === 2) {
      window.location.reload();
      return;
    }

    // If moving FROM Wallet Config (index 1) TO Admin Account (index 2)
    if (activeIndex === 1) {
      if (isAlreadyExisting) {
        // Editing existing partner - stay on partner-profile URL
        navigate(`/partners/partner-profile/${operatorId}/${partnerId}`, {
          replace: true,
        });
      } else {
        // Creating new partner - go to add-profile URL
        navigate(`/partners/add-profile/${operatorId}/${partnerId}`, {
          replace: true,
        });
      }
    }

    // Only update URL if we're creating a NEW partner
    // Moving FROM Profile (index 0) TO Wallet Config (index 1)
    // if (activeIndex === 0 && partnerId !== undefined && !isAlreadyExisting) {
    //   navigate(`/partners/add-profile/${operatorId}/${partnerId}`, {
    //     replace: true,
    //   });
    // }

    // Move to next step
    setActiveIndex(nextIndex);
  };

  return (
    <div>
      {/* <Breadcrumbs items={breadcrumbItems} /> */}
      {/* <p className="font-bold col-span-4">
        {partnerCategoryItems.find(
          (x) => x.value === partnerProfileData.partnerCategoryNo
        ) &&
          partnerCategoryItems.find(
            (x) => x.value === partnerProfileData.partnerCategoryNo
          ).name}
      </p> */}

      <div className="w-full mb-8 px-20">
        {" "}
        {/* Outer container with padding */}
        <div className="flex items-center justify-between relative">
          {items.map((item, index) => (
            <div
              key={index}
              className="flex flex-col items-center flex-1 relative"
            >
              {/* Connecting Line - only between steps */}
              {index < items.length - 1 && (
                <div
                  className={`absolute top-6 left-1/2 w-full h-0.5 z-0 ${
                    index < activeIndex ? "bg-blue-500" : "bg-gray-300"
                  }`}
                />
              )}

              {/* Step Circle */}
              <div className="relative z-10 flex flex-col items-center">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center text-lg font-semibold transition-all ${
                    index <= activeIndex
                      ? "bg-blue-500 text-white"
                      : "bg-gray-300 text-gray-600"
                  }`}
                >
                  {index + 1}
                </div>
                <div
                  className={`mt-2 text-sm font-medium text-center ${
                    index <= activeIndex ? "text-gray-900" : "text-gray-400"
                  }`}
                >
                  {item.label}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {activeIndex === 0 ? (
        <PartnerProfileForm
          isEditing={true}
          partnerProfileData={partnerProfileData}
          partnerCategory={
            partnerCategoryItems.find(
              (x) => x.value === partnerProfileData.partnerCategoryNo,
            ) &&
            partnerCategoryItems.find(
              (x) => x.value === partnerProfileData.partnerCategoryNo,
            ).name
          }
          partnerCategoryItems={partnerCategoryItems}
          partnerTypesItems={partnerTypesItems}
          contactPersonFields={contactPersonFields}
          paymentSchedulesItem={paymentSchedulesItem}
          changesMade={changesMade}
          handleOnChange={handleOnChange}
          isEditingPaymentScheduleNo={
            partnerProfileData.paymentScheduleNo === 0
              ? -2
              : partnerProfileData.paymentScheduleNo
          }
          isAlreadyExisting={isAlreadyExisting}
          handleResetFeatures={handleResetFeatures}
          handleSaveChanges={handleSaveChanges}
          handleCancelChanges={handleCancelChanges}
          setValidation={setValidation}
          goToNextStep={goToNextStep}
          accessPermission={accessPermission}
        />
      ) : activeIndex === 1 ? (
        <PartnerWalletConfiguration
          partnerProfileData={partnerProfileData}
          handleOnChange={handleOnChange}
          accessPermission={accessPermission}
          changesMade={changesMade}
          isLoading={loading}
          handleSaveChanges={handleSaveChanges}
          setValidation={setValidation}
          goToNextStep={goToNextStep}
          setActiveIndex={setActiveIndex}
          handleCancelChanges={handleCancelChanges}
        />
      ) : (
        <>
          <PartnerAdminAccount
            setActiveIndex={setActiveIndex}
            accessPermissions={accessPermission}
          />
        </>
      )}

      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </div>
  );
}
export default function PartnerProfile({ partnerProfileData }) {
  return <PartnerProfileComponent />;
}
